export default __webpack_public_path__ + "static/media/chat.d5d9caa0.svg";